module.exports = __webpack_public_path__ + "img/credit-card-main.31b1439.webp";